import React from 'react';
import PropTypes from 'prop-types';

import './section.styles.scss';

export default function Section({
  children,
  id = '',
  className = '',
  sx = {},
}) {
  return (
    <div
      id={id}
      className={'section-container' + (className ? ` ${className}` : '')}
      style={sx}
    >
      {children}
    </div>
  );
}

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  sx: PropTypes.object,
};
